/**
 * @generated SignedSource<<c5e83aafdca5c6084a555f8913d505b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignalWorkspaceTemplateSelector_SignalWorkspace$data = {
  readonly body: string | null;
  readonly descriptionFiles: ReadonlyArray<{
    readonly __typename: "File";
  }>;
  readonly descriptionImages: ReadonlyArray<{
    readonly __typename: "Image";
  }>;
  readonly id: string;
  readonly template: {
    readonly id: string;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"SignalWorkspaceTemplateSelectorTemplateItem_SignalWorkspaceTemplate">;
  } | null;
  readonly title: string;
  readonly updatedBy: {
    readonly __typename: "User";
  } | null;
  readonly " $fragmentType": "SignalWorkspaceTemplateSelector_SignalWorkspace";
};
export type SignalWorkspaceTemplateSelector_SignalWorkspace$key = {
  readonly " $data"?: SignalWorkspaceTemplateSelector_SignalWorkspace$data;
  readonly " $fragmentSpreads": FragmentRefs<"SignalWorkspaceTemplateSelector_SignalWorkspace">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SignalWorkspaceTemplateSelector_SignalWorkspace",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "updatedBy",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "descriptionFiles",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "descriptionImages",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SignalWorkspaceTemplate",
      "kind": "LinkedField",
      "name": "template",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SignalWorkspaceTemplateSelectorTemplateItem_SignalWorkspaceTemplate"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SignalWorkspace",
  "abstractKey": null
};
})();

(node as any).hash = "341f704fad3d820ff3f1acf96732335d";

export default node;
